import { useState, useEffect, useCallback } from 'react';
import { 
  getCompanyCreditTransactions, 
  FirestoreCreditTransaction 
} from '../services/creditService';

// Hook for getting credit transactions
export const useGetCreditTransactions = (
  companyId: string | null, 
  limit: number = 50,
  options?: { enabled?: boolean }
) => {
  const [data, setData] = useState<{ creditTransactions: FirestoreCreditTransaction[] }>({ creditTransactions: [] });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchTransactions = useCallback(async () => {
    if (!companyId || (options?.enabled === false)) return;
    
    setIsLoading(true);
    setError(null);
    
    try {
      const transactions = await getCompanyCreditTransactions(companyId, limit);
      setData({ creditTransactions: transactions });
    } catch (err) {
      setError(err as Error);
    } finally {
      setIsLoading(false);
    }
  }, [companyId, limit, options?.enabled]);

  useEffect(() => {
    fetchTransactions();
  }, [companyId, limit, options?.enabled, fetchTransactions]);

  return {
    data,
    isLoading,
    error,
    refetch: fetchTransactions
  };
};
